<template>
  <section id="section-login">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <a href="" class="logo-login">
            <img src="@/assets/images/rockstar-logo.png" alt="">
          </a>
        </div>
      </div>

      <div class="row align-items-center flex-row">
        <div class="col-md-6">

          <div class="login-box">
            <h2 class="">Welcome Back!</h2>
            <p>Please Enter your Account details.</p>

            <form @submit.prevent="handleLogin">
              <div class="input-wrapper">
                <label for="email">Your Email</label>
                <input type="email" class="form-control" id="email" v-model="email" />
                <p v-if="errors.email" class="error-text">{{ errors.email }}</p>
              </div>

              <div class="input-wrapper">
                <!-- <label class="pass-label" for="password">Password
                  <a href="#" class="forgot-link">Forgot your password?</a>
                </label> -->
                <label for="email">Your Password</label>
                <input type="password" class="form-control" id="password" v-model="password" />
                <p v-if="errors.password" class="error-text">{{ errors.password }}</p>
              </div>

              <p v-if="errors.api" class="error-text">{{ errors.api }}</p>
              <button type="submit" class="btn btn-login w-100 mt-3">Log in</button>
            </form>

          </div>


        </div>
        <div class="col-md-6">
          <div>
            <img src="@/assets/images/login-banner-image (1).png" alt="" class="w-100">
          </div>
        </div>
      </div>

    </div>
  </section>

</template>

<script>
import axios from 'axios';

export default {
  name: 'LoginMain',
  inject: ['api'],
  
  props: {
    msg: String
  },
  data() {
    return {
      email: '',
      password: '',
      errors: {
        email: '',
        password: '',
        api: ''
      }
    };
  },
  methods: {
    async handleLogin() {
      this.clearErrors();

      if (!this.email) {
        this.errors.email = 'Email is required.';
      }
      if (!this.password) {
        this.errors.password = 'Password is required.';
      }
      if (this.errors.email || this.errors.password) {
        return;
      }

      try {
        const response = await axios.post(
          `${this.api.base_url}/user/login`,
          {
            email: this.email,
            password: this.password,
            device_type: this.api.device_type,
            device_token: this.api.device_token
          },
          {
            headers: {
              token: this.api.token,
            }
          }
        );
        console.log('Login successful:', response.data.data);


        localStorage.setItem('rockstar_user', JSON.stringify(response.data.data));
        localStorage.setItem('rockstar_token', this.$encryptData(response.data.data.api_token));

        this.$router.push({ name: 'Home' });
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.errors.api = 'Invalid credentials. Please try again.';
        } else {
          this.errors.api = 'An error occurred. Please try again.';
        }
      }
    },
    clearErrors() {
      this.errors.email = '';
      this.errors.password = '';
      this.errors.api = '';
    }
  },
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.error-text {
  color: red;
  font-size: 0.9em;
  margin-top: 5px;
}
</style>